import { useCallback } from 'react';
import getColour from '@lendi-ui/commons/colours';
import { Dollar } from '@lendi-ui/icon';

import { useUpdateExpenseJoinAmount } from '@funnels/hooks';

import { Prefix } from '../../_common';
import UncontrolledNumericalInputField from '../../Fields/_uncontrolled/NumericalInputField';
import { EditableViewProps } from '../types';
import { Wrapper } from './ExpenseJoinAmountTeamView.style';

interface ExpenseJoinAmountTeamViewProps extends EditableViewProps {
  currentExpensesIndex: number;
  currentExpensesExpenseIndex: number;
  partnerExpensesIndex: number;
  partnerExpensesExpenseIndex: number;
}

export const ExpenseJoinAmountTeamView = (props: ExpenseJoinAmountTeamViewProps) => {
  const {
    currentExpensesIndex,
    currentExpensesExpenseIndex,
    partnerExpensesIndex,
    partnerExpensesExpenseIndex,
    isDisabled,
  } = props;

  const [jointAmount, setJointAmountValue] = useUpdateExpenseJoinAmount(
    [currentExpensesIndex, partnerExpensesIndex],
    [currentExpensesExpenseIndex, partnerExpensesExpenseIndex]
  );

  const handleChange = useCallback((value) => {
    setJointAmountValue(value);
  }, []);

  return (
    <Wrapper>
      <UncontrolledNumericalInputField
        before={
          <Prefix>
            <Dollar color={getColour('text', 'subtle')} />
          </Prefix>
        }
        isDecimalValid={true}
        isZeroValid={true}
        value={jointAmount?.toString()}
        onChange={handleChange}
        isDisabled={isDisabled}
      />
    </Wrapper>
  );
};
